"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newTimerPinComponent = exports.minimumTimerComponentSize = void 0;
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
const pin_component_1 = require("./pin-component");
exports.minimumTimerComponentSize = (0, geometry_1.newSize)(300, 180);
function newTimerPinComponent({ position = pin_component_1.initialPinComponentPosition, size = exports.minimumTimerComponentSize, order = order_1.defaultOrder, settings = {
    seconds: 60,
    borderSize: 1,
    borderColor: '#14171f33',
}, }) {
    if (size.width < exports.minimumTimerComponentSize.width || size.height < exports.minimumTimerComponentSize.height) {
        throw new Error(`Timer component size ${sizeToString(size)} is too small; ` +
            `need at least ${sizeToString(exports.minimumTimerComponentSize)}`);
    }
    return {
        type: 'TIMER',
        id: (0, random_id_1.randomId)(),
        settings,
        layout: (0, geometry_1.newBox)(position, size, 0, true),
        order,
    };
}
exports.newTimerPinComponent = newTimerPinComponent;
function sizeToString(size) {
    return `(${size.width}, ${size.height})`;
}
//# sourceMappingURL=timer-pin-component.js.map